export default __webpack_public_path__ + "static/media/inprogress_sp_ticket.10858220.svg";